import { floor } from '../util/math/Math'
import { nextIntRange } from './index'
import { RNGConfig } from './RNGConfig.type'

export default function randomElement<T>(array: Readonly<Array<T>>, rng: RNGConfig): T {
  const index = floor(nextIntRange(0, array.length - 1, rng))
  return array[index]
}
